import { render } from "./CreateTicket.vue?vue&type=template&id=90b52b20&scoped=true"
import script from "./CreateTicket.vue?vue&type=script&lang=js"
export * from "./CreateTicket.vue?vue&type=script&lang=js"

import "./CreateTicket.vue?vue&type=style&index=0&id=90b52b20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90b52b20"]])

export default __exports__